// extracted by mini-css-extract-plugin
export default {"box":"sub-nav_box__Q5lzj","tab":"sub-nav_tab__OODwz","scroller":"sub-nav_scroller__ubtn0","selected":"sub-nav_selected__WtoLb"};